import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { ServicingBaseComponent } from '@common/components';
import { ServicingCommonStoreService } from '@common/services/servicing-common-store/servicing-common-store.service';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { PREVIOUS_PAGE_IDENTIFIER } from '@common/interfaces';

@Component({
  selector: 'asw-reservation-basic-information-input-sub-header',
  templateUrl: './reservation-basic-information-input-sub-header.component.html',
  styleUrls: ['./reservation-basic-information-input-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReservationBasicInformationInputSubHeaderComponent extends ServicingBaseComponent {
  /** 戻るボタン表示フラグ */
  protected isDisplayBackButton: boolean = false;
  /** サービシングルーター定義 */
  protected SERVICING_ROUTES = SERVICING_ROUTES;

  constructor(common: CommonLibService, private servicingCommonStoreService: ServicingCommonStoreService) {
    super(common);
  }

  override init(): void {
    this.subscribeService(this.servicingCommonStoreService.getServicingCommonModel$(), (state) => {
      if (state.previousPageIdentifier) {
        this.isDisplayBackButton = state.previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.MYBOOKING;
      }
    });
  }
  override reload(): void {}
  override destroy(): void {}
}
